export const JOB_ADS_FO_ALGOLIA_INDEX_FROM_UNLEASH = "algolia_index_permanent_ab_test"

export const CANDIDACY_TYPE_FILTER_UNLEASH_EXPERIMENT = "easy_apply_feature"
export const CANDIDACY_TYPE_FILTER_UNLEASH_FEATURE_VARIANTS = {
  DISABLED: "feature_off",
  ENABLED: "feature_on",
}

export const JOB_ADS_FO_SAVED_SEARCHES = "saved_searches"
export const JOB_ADS_FO_SAVED_SEARCHES_VARIANTS = {
  DISABLED: "feature_off",
  ENABLED: "feature_on",
}

export const JOB_ADS_FO_ALGOLIA_DEBUG = "algolia_debug"

export const JOB_ADS_FO_SAVED_SEARCHES_VS_JOB_ALERT = "jobads_saved_searches_vs_job_alert_section"
